<template>
  <v-card flat v-if="isThrottled">{{ $t("components.RatingForm.throttled") }}</v-card>
  <v-card flat v-else-if="!isSubmitted">
    <v-card-title v-if="title">{{ title }}</v-card-title>
    <v-card-text v-if="description">{{ description }}</v-card-text>
    <v-rating
      hover
      v-model="ratingEntity.rating"
      length="5"
      large
      :disabled="isSubmitted"
      :background-color="color"
      class="pb-4 px-0"
      label="Test"
    >
    </v-rating>
    <div v-if="ratingEntity.rating">
      <v-textarea :label="label" outlined v-model="ratingEntity.message" :disabled="isSubmitted"></v-textarea>
      <v-card-actions class="px-0">
        <v-btn
          dark
          @click="submitRating"
          :color="color"
          elevation="0"
          :loading="ratingEntity.loading"
          :disabled="!ratingEntity.rating"
          data-test-submit-rating
        >
          {{ $t("components.RatingForm.submit") }}
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
  <v-card flat v-else>
    <v-card-text class="px-0"> {{ $t("components.RatingForm.thankYou") }}</v-card-text>
    <slot />
  </v-card>
</template>

<script lang="ts">
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { RatingEntity } from "@/models/rating.entity";
import { RatingModule } from "@/store/modules/rating.store";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Prop, Vue } from "vue-property-decorator";

const CREATED = "created";

@Component({
  components: {}
})
export default class RatingForm extends Vue {
  @Prop({ default: "default" })
  ratingKey!: string;

  @Prop({ default: "" })
  title!: string;

  @Prop({ default: "" })
  description!: string;

  ratingEntity = new RatingEntity();

  get label() {
    if (this.ratingEntity.rating < 3) {
      return this.$t("components.RatingForm.label.bad");
    } else if (this.ratingEntity.rating === 3) {
      return this.$t("components.RatingForm.label.medium");
    } else {
      return this.$t("components.RatingForm.label.good");
    }
  }

  get key() {
    if (RatingModule.ratingKey) {
      return RatingModule.ratingKey;
    }

    return this.ratingKey;
  }

  get isThrottled() {
    return RatingModule.isThrottled;
  }

  get isSubmitted() {
    return RatingModule.ratingSubmitted;
  }

  mounted() {
    this.ratingEntity = new RatingEntity();
  }

  async submitRating() {
    this.ratingEntity.key = this.key;
    try {
      await this.ratingEntity.createRating(ReportModule.partner.id || ReportModule.partner._id);
      RatingModule.setRatingSubmitted(true);
      this.$emit(CREATED, this.ratingEntity);
    } catch (error) {
      this.$log.error(error);
      this.$toast.error(this.$t("components.RatingForm.error"));
    }
  }

  get color() {
    return getDefaultPartnerColor();
  }
}
</script>
